(function () {

    const widgets = document.querySelectorAll(
        '.calendly-inline-widget'
    );

    if (!widgets.length) {
        return;
    }

    const existingScript = document.querySelector(
        'script[src*="assets.calendly.com/assets/external/widget.js"]'
    );

    if (existingScript) {
        return;
    }

    const script = document.createElement('script');

    script.src =
        'https://assets.calendly.com/assets/external/widget.js';

    script.async = true;

    document.body.appendChild(script);

})();